<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of Alabama</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Welcome_to_Spooky_Alabama#Wel">Welcome to Spooky Alabama!</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Haunted Houses</span></td></tr>
<tr><td>1</td><td><span href="#/Chapter01#C1-1" title="Link target outside of Sample">Cedarhurst Mansion, Huntsville</span></td></tr>
<tr><td>2</td><td><span href="#/Chapter01#C1-2" title="Link target outside of Sample">Bluff Hall, Demopolis</span></td></tr>
<tr><td>3</td><td><span href="#/Chapter01#C1-3" title="Link target outside of Sample">Cleveland House, Suggsville</span></td></tr>
<tr><td>4</td><td><span href="#/Chapter01#C1-4" title="Link target outside of Sample">Gaineswood, Demopolis</span></td></tr>
<tr><td>5</td><td><span href="#/Chapter01#C1-5" title="Link target outside of Sample">Kendall Manor, Eufaula</span></td></tr>
<tr><td>6</td><td><span href="#/Chapter01#C1-6" title="Link target outside of Sample">Lakewood, Livingston</span></td></tr>
<tr><td>7</td><td><span href="#/Chapter01#C1-7" title="Link target outside of Sample">Sturdivant Hall, Selma</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Haunted Colleges and Universities</span></td></tr>
<tr><td>8</td><td><span href="#/Chapter02#C2-8" title="Link target outside of Sample">Athens State University, Athens</span></td></tr>
<tr><td>9</td><td><span href="#/Chapter02#C2-9" title="Link target outside of Sample">Auburn State University, Auburn</span></td></tr>
<tr><td>10</td><td><span href="#/Chapter02#C2-10" title="Link target outside of Sample">Spring Hill College, Mobile</span></td></tr>
<tr><td>11</td><td><span href="#/Chapter02#C2-11" title="Link target outside of Sample">University of Alabama,Tuscaloosa</span></td></tr>
<tr><td>12</td><td><span href="#/Chapter02#C2-12" title="Link target outside of Sample">University of Montevallo, Montevallo</span></td></tr>
<tr><td>13</td><td><span href="#/Chapter02#C2-13" title="Link target outside of Sample">University of North Alabama, Florence</span></td></tr>
<tr><td>14</td><td><span href="#/Chapter02#C2-14" title="Link target outside of Sample">University of West Alabama, Livingston</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Haunted Buildings</span></td></tr>
<tr><td>15</td><td><span href="#/Chapter03#C3-15" title="Link target outside of Sample">Sloss Furnaces, Birmingham</span></td></tr>
<tr><td>16</td><td><span href="#/Chapter03#C3-16" title="Link target outside of Sample">Lucas Tavern, Montgomery</span></td></tr>
<tr><td>17</td><td><span href="#/Chapter03#C3-17" title="Link target outside of Sample">Old Bryce Hospital, Tuscaloosa</span></td></tr>
<tr><td>18</td><td><span href="#/Chapter03#C3-18" title="Link target outside of Sample">Pickens County Courthouse, Carrollton</span></td></tr>
<tr><td>19</td><td><span href="#/Chapter03#C3-19" title="Link target outside of Sample">Tallassee Public Library, Tallassee</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Haunted Outdoors</span></td></tr>
<tr><td>20</td><td><span href="#/Chapter04#C4-20" title="Link target outside of Sample">Boyington Oak, Mobile</span></td></tr>
<tr><td>21</td><td><span href="#/Chapter04#C4-21" title="Link target outside of Sample">Cry Baby Hollow, Hartselle</span></td></tr>
<tr><td>22</td><td><span href="#/Chapter04#C4-22" title="Link target outside of Sample">The Harrison Cemetery, Coffee County</span></td></tr>
<tr><td>23</td><td><span href="#/Chapter04#C4-23" title="Link target outside of Sample">Tombigbee River, Pennington</span></td></tr>
<tr><td>24</td><td><span href="#/Chapter04#C4-24" title="Link target outside of Sample">Huggin’ Molly, Abbeville</span></td></tr>
<tr><td colspan="2"><span href="#/A_Ghostly_Goodbye#Gho" title="Link target outside of Sample">A Ghostly Goodbye</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?f2220fee